import { Component, OnDestroy } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { DrawerService } from '../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../core/constants/drawer-ids.constant';
import {
  TemplateDetailParams,
  TemplateLogs,
} from '../../bip-template.interface';
import { Subject, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { AuditType } from '../../bip-template.enums';
import { UserDatePipe } from '../../../../shared/pipes/user-date.pipe';

@Component({
  selector: 'app-template-log-details',
  standalone: true,
  imports: [SvgIconComponent, NzDividerModule, CommonModule, UserDatePipe],
  templateUrl: './template-log-details.component.html',
  styleUrl: './template-log-details.component.scss',
})
export class TemplateLogDetailsComponent implements OnDestroy {
  private destroy$ = new Subject<void>();
  logDetail: TemplateLogs | null = null;
  AuditTypeEnums = AuditType;
  constructor(private drawerService: DrawerService) {
    this.setupDrawerParams();
  }

  private setupDrawerParams(): void {
    this.drawerService
      .getParams<TemplateDetailParams>(DRAWER_IDS.TEMPLATE_LOGS_DETAIL)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.logDetail = params.selectedLog;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
